import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import strings from "../../../localization/strings"
import { ISpecialtyInfo } from "../../../models"
import ChooseSpecialtyDialogForChip from "./ChooseSpecialtyDialogForChip"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
	readonly
	maxWidth?: number
	selectedSpecialties?: ISpecialtyInfo[]
	handleSave(Specialties: ISpecialtyInfo[]): void
	handleDelete(Specialties: ISpecialtyInfo[]): void
}
interface IState {
	selectedSpecialties: ISpecialtyInfo[]
	openChooseDialog: boolean
}

export default class ChooseSpecialtyChip extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			selectedSpecialties: props.selectedSpecialties,
			openChooseDialog: false,
		}
	}

	render() {
		return !(this.props.readonly && this.props.selectedSpecialties.length > 0) && (
			<div style={{ paddingTop: 20, width: 350 }}>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{strings.Specialties}
				</div>
				<div style={{ display: "flex", flexWrap: "wrap", }}>
					{this.state.selectedSpecialties && this.state.selectedSpecialties.length > 0 &&
						this.state.selectedSpecialties.map((specialty, index) => (
							<Chip
								key={index}
								style={{ margin: 2, height: 35, width: "min-content", }}
								onRequestDelete={this.props.readonly ?
									null :
									() => {
										const selectedSpecialties = this.state.selectedSpecialties.filter((_specialty, _index) => _index !== index)
										this.setState({ selectedSpecialties })
										this.props.handleDelete(selectedSpecialties)
									}
								}
							>
								<div
									className="TextOverflow"
									title={specialty.Name}
									style={{ maxWidth: this.props.maxWidth }}
								>
									{specialty.Name}
								</div>
							</Chip>
						))
					}
					{!this.props.readonly &&
						<IconButton
							style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
							onTouchTap={() => this.setState({ openChooseDialog: true })}
						>
							<FontIcon className="fa fa-plus-circle" />
						</IconButton>
					}
					{this.state.openChooseDialog &&
						<ChooseSpecialtyDialogForChip
							handleClose={() => this.setState({ openChooseDialog: false })}
							handleSave={selectedSpecialties => {
								this.state.selectedSpecialties.find(i => selectedSpecialties.map(j => j.Id).includes(i.Id)) ?
									AppStateStore.setAlertDialogContent({
										content: strings.Duplicated_specialty_exist
									}) :
									this.setState({
										openChooseDialog: false,
										selectedSpecialties: [...this.state.selectedSpecialties, ...selectedSpecialties]
									})
								this.props.handleSave(selectedSpecialties)
							}}
						/>
					}
				</div>
			</div>
		)
	}
}